declare global {
  interface Window {
    // Only present when app/views/layouts/application.html.erb has loaded the
    // PostHog snippet — production, signed-out visitors only. Every call here
    // must stay optional-chained so it's a silent no-op everywhere else.
    posthog?: {
      capture: (event: string, properties?: Record<string, unknown>) => void
      opt_out_capturing: () => void
    }
  }
}

export function captureEvent(event: string, properties?: Record<string, unknown>) {
  window.posthog?.capture(event, properties)
}

// Called once the app entrypoint sees an authenticated `nav` shared prop
// (see app/javascript/entrypoints/inertia.tsx). The layout's ERB guard only
// runs on a full page load, and Inertia navigates without one, so this is
// the backstop that keeps signed-in sessions out of the shared PostHog
// project.
export function disableCapturing() {
  window.posthog?.opt_out_capturing()
}
